(function () {
  var MOBILE_MAX = 576;

  function closeCard(c) {
    c.classList.remove('is-plus-open');
    var b = c.querySelector('[data-card-plus]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-card-plus]');
    var openCards = document.querySelectorAll('product-card.is-plus-open');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      var card = plus.closest('product-card');
      var willOpen = !card.classList.contains('is-plus-open');
      openCards.forEach(closeCard);
      if (willOpen) {
       
        var media = card.querySelector('.product-card__media');
        if (media) card.style.setProperty('--media-h', media.offsetHeight + 'px');
        card.classList.remove('has-size-picked');
        card.classList.add('is-plus-open');
        plus.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.product-card__information-bottom')) {
      openCards.forEach(closeCard);
    }
  }, true);

  
  function findVariant(card) {
    var dataEl = card.querySelector('[data-product-card-variants]');
    if (!dataEl) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return null; }
    var selected = {};
    card.querySelectorAll('.js-card-option-group input:checked').forEach(function (inp) {
      var group = inp.closest('.js-card-option-group');
      var pos = group && group.dataset.optionPosition;
      if (pos) selected['option' + pos] = inp.value;
    });
    var matches = variants.filter(function (v) {
      return Object.keys(selected).every(function (k) { return v[k] === selected[k]; });
    });
    return matches.find(function (v) { return v.available; }) || null;
  }

  
  document.addEventListener('click', function (e) {
    if (window.innerWidth > MOBILE_MAX) return;
    var input = e.target.closest('.product-card__information-bottom input[type="radio"]');
    if (!input || input.classList.contains('disabled')) return;
    var card = input.closest('product-card');
    if (!card || !card.classList.contains('is-plus-open')) return;
    if (card.dataset.plusAdding === 'true') return;

    card.classList.add('has-size-picked');


    setTimeout(function () {
      var variant = findVariant(card);
      var form = card.querySelector('.product-card__plus-add');
      var btn = form && form.querySelector('button[type="submit"]');
      var idInput = form && form.querySelector('input[name="id"]');
      if (!variant || !btn || !idInput) return;
      idInput.value = variant.id;
      idInput.disabled = false;
      btn.setAttribute('aria-disabled', 'false');
      card.dataset.plusAdding = 'true';
      btn.click();
      setTimeout(function () {
        card.dataset.plusAdding = 'false';
        closeCard(card);
      }, 700);
    }, 120);
  });
})();
